// UC1 — Alkeme CMDB wordmark for the expanded sidebar.
// Plain SVG text so we don't ship a binary asset. Colors lifted from the
// alkemeins.com design tokens in alkeme-marketing
// (sites/*/app/globals.css): #ffbf3b (--color-gold) for the brand word,
// #f5f1e8 (--color-cream) for the product suffix. Chosen for legibility
// on the dark sidebar — the primary brand navy #25475e would be invisible
// against Backstage's dark chrome.

import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 32,
    display: 'block',
  },
  alkeme: {
    fill: '#ffbf3b',
  },
  cmdb: {
    fill: '#f5f1e8',
  },
});

export const LogoFull = () => {
  const classes = useStyles();
  return (
    <svg
      className={classes.svg}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 300 40"
    >
      <text
        x="0"
        y="30"
        fontFamily="'Helvetica Neue', Helvetica, Arial, sans-serif"
        fontSize="32"
        fontWeight="700"
        letterSpacing="-1.2"
      >
        <tspan className={classes.alkeme}>Alkeme</tspan>
        <tspan className={classes.cmdb}> IT Portal</tspan>
      </text>
    </svg>
  );
};
